/**
 * Mirrors the server's RBAC catalogue value for value. Only the values matter here: the server is
 * the sole source of label, description and category, delivered in French through the permissions
 * endpoint.
 */
export enum PermissionEnum {
	ACCOUNT_READ = 'ACCOUNT_READ',
	ACCOUNT_WRITE = 'ACCOUNT_WRITE',
	ACCOUNT_LOGO_WRITE = 'ACCOUNT_LOGO_WRITE',
	ACCOUNT_RETENTION_WRITE = 'ACCOUNT_RETENTION_WRITE',
	FACILITY_READ = 'FACILITY_READ',
	FACILITY_WRITE = 'FACILITY_WRITE',
	FACILITY_ORGANIZATION_READ = 'FACILITY_ORGANIZATION_READ',
	SUBJECT_TYPE_MANAGE = 'SUBJECT_TYPE_MANAGE',
	SUBJECT_WRITE = 'SUBJECT_WRITE',
	SUBJECT_REMOVE = 'SUBJECT_REMOVE',
	INTERVIEW_WRITE = 'INTERVIEW_WRITE',
	INTERVIEW_DELETE = 'INTERVIEW_DELETE',
	TRANSCRIPT_EXPORT = 'TRANSCRIPT_EXPORT',
	USER_READ = 'USER_READ',
	USER_READ_ACCOUNT = 'USER_READ_ACCOUNT',
	USER_WRITE = 'USER_WRITE',
	USER_ACTIVATE = 'USER_ACTIVATE',
	USER_DEACTIVATE = 'USER_DEACTIVATE',
	USER_MFA_RESET = 'USER_MFA_RESET',
	ROLE_MANAGEMENT = 'ROLE_MANAGEMENT',
	SYSTEM_CONFIG = 'SYSTEM_CONFIG',
	ORGANIZATION_READ = 'ORGANIZATION_READ',
	ORGANIZATION_WRITE = 'ORGANIZATION_WRITE',
	ORGANIZATION_CONSOLIDATED_READ = 'ORGANIZATION_CONSOLIDATED_READ',
	SSO_MANAGEMENT = 'SSO_MANAGEMENT',
	AUDIT_READ = 'AUDIT_READ',
	STAFF_READ = 'STAFF_READ',
	STAFF_WRITE = 'STAFF_WRITE',
	STAFF_DELETE = 'STAFF_DELETE',
	STAFF_FACILITY_ASSIGN = 'STAFF_FACILITY_ASSIGN',
	AI_PROVIDER_READ = 'AI_PROVIDER_READ',
	AI_PROVIDER_WRITE = 'AI_PROVIDER_WRITE',
	AI_PROVIDER_DELETE = 'AI_PROVIDER_DELETE',
	AI_MODEL_READ = 'AI_MODEL_READ',
	AI_MODEL_WRITE = 'AI_MODEL_WRITE',
	AI_MODEL_DELETE = 'AI_MODEL_DELETE',
	AI_ACCOUNT_ASSIGNMENT_READ = 'AI_ACCOUNT_ASSIGNMENT_READ',
	AI_ACCOUNT_ASSIGNMENT_WRITE = 'AI_ACCOUNT_ASSIGNMENT_WRITE',
	AI_ACCOUNT_ASSIGNMENT_DELETE = 'AI_ACCOUNT_ASSIGNMENT_DELETE',
	AI_ASSIGNMENT_READ = 'AI_ASSIGNMENT_READ',
	AI_ASSIGNMENT_WRITE = 'AI_ASSIGNMENT_WRITE',
	AI_ASSIGNMENT_DELETE = 'AI_ASSIGNMENT_DELETE',
	DOCUMENT_TYPE_WRITE = 'DOCUMENT_TYPE_WRITE',
	DOCUMENT_TEMPLATE_READ = 'DOCUMENT_TEMPLATE_READ',
	DOCUMENT_TEMPLATE_WRITE = 'DOCUMENT_TEMPLATE_WRITE',
	DOCUMENT_TEMPLATE_ARCHIVE = 'DOCUMENT_TEMPLATE_ARCHIVE',
	DOCUMENT_GENERATION_LAUNCH = 'DOCUMENT_GENERATION_LAUNCH',
	DOCUMENT_EXPORT = 'DOCUMENT_EXPORT',
	DOCUMENT_DELETE = 'DOCUMENT_DELETE',
	WORKFLOW_RUN_FACILITY_READ = 'WORKFLOW_RUN_FACILITY_READ',
	AI_USAGE_READ = 'AI_USAGE_READ',
	AI_COST_LIMIT_WRITE = 'AI_COST_LIMIT_WRITE',
}
